export const lyric01 = `You got me sippin' on something
I can't compare to nothing
I've ever known, I'm hoping
That after this fever I'll survive
I know I'm acting a bit crazy
Strung out, a little bit hazy
Hand over heart, I'm praying
That I'm gonna make it out alive
The bed's getting cold and you're not here
The future that we hold is so unclear
But I'm not alive until you call
And I'll bet the odds against it all
Save your advice 'cause I won't hear
You might be right, but I don't care
There's a million reasons why I should give you up
But the heart wants what it wants
The heart wants what it wants
You got me scattered in pieces
Shining like stars and screaming
Lighting me up like Venus
But then you disappear and make me wait
And every second's like torture
Heroin drip, no more so
Finding a way to let go
Baby, baby, no, I can't escape
The bed's getting cold and you're not here
The future that we hold is so unclear
But I'm not alive until you call
And I'll bet the odds against it all
Save your advice 'cause I won't hear
You might be right, but I don't care
There's a million reasons why I should give you up
But the heart wants what it wants
The heart wants what it wants
The heart wants what it wants
The heart wants what it wants
This is a modern fairy tale
No happy endings
No wind in our sails
But I can't imagine a life without
Breathless moments
Breaking me down, down, down, down
The bed's getting cold and you're not here
The future that we hold is so unclear
But I'm not alive until you call
And I'll bet the odds against it all
Save your advice 'cause I won't hear
You might be right, but I don't care
There's a million reasons why I should give you up
But the heart wants what it wants
The heart wants what it wants
The heart wants what it wants
The heart wants what it wants
The heart wants what it wants, baby
It wants what it wants, baby
It wants what it wants
It wants what it wants
The heart wants what it wants, baby
It wants what it wants`